import { Outlet } from 'react-router-dom';
import Home from './app/pages/layout/Home';

function App() {
  return (
    <div className="App">
      <Home></Home>
      <Outlet />
    </div>
  );
}

export default App;
